<template>
	<div class="text-xs-center filter">
		<div v-if="filter.type == 'text'" class="col-md-12" style="padding-left:18px">
			<input
				type="text"
				class="col-md-12 form-control"
				v-model="filter.value"
				:label="filter.label"
				v-bind="filter.props"
			>
		</div>

		<div v-else-if="filter.type == 'number'" style="padding-left:18px" class="col-md-12">
			<input
				type="number"
				style="padding-left:10px"
				class="col-md-12 form-control"
				v-model="filter.value"
				:label="filter.label"
				v-bind="filter.props"
			>
		</div>

		<div v-else-if="filter.type == 'date'">
			<div class="row" style="padding:4px;margin-left:1px">
				<label class="col-md-3">From:</label>
				<input
					class="col-md-8 form-control"
					type="date"
					v-model="filter.value[0]"
					:label="filter.label"
					v-bind="filter.props"
				>
			</div>
			<div class="row" style="padding:4px;margin-left:1px">
				<label class="col-md-3" style="margin-top:3px">To:</label>
				<input
					class="col-md-8 form-control"
					style="margin-top:3px;"
					type="date"
					v-model="filter.value[1]"
					:label="filter.label"
					v-bind="filter.props"
				>
			</div>
		</div>

		<div v-else-if="filter.type == 'select'" :style="filter.padding? 'margin-bottom:20px':''" >
			<multiselect
				v-model="filter.value"
				class="form-control multi-dropdown"
				:placeholder="filter.placeholder"
				:label="filter.listLabel?filter.listLabel:'name'"
				deselectLabel=""
				selectedLabel=""
				selectLabel=""
				@search-change="fetchDynamicList()"
				:options="filter.values"
				:track-by="filter.track?filter.track:'name'"
				id="select"
				:multiple="false"
				:taggable="false"
				style="height:43px"
				open-direction="bottom"
			></multiselect>
		</div>
		<div v-else-if="filter.type == 'selectsubHierarchy'" >
			<multiselect
				v-model="filter.value"
				@search-change="fetchDynamicList('selectsubHierarchy')"
				id="selectsubHierarchy"
				class="form-control multi-dropdown"
				:placeholder="filter.placeholder"
				label="name"
				deselectLabel=""
				selectedLabel=""
				selectLabel=""
				:options="filter.values"
				track-by="name"
				:multiple="false"
				:taggable="false"
			></multiselect>
		</div>
		<div v-else-if="filter.type == 'selectHierarchy'" >
			<multiselect
				v-model="filter.value"
				@search-change="fetchDynamicList('selectHierarchy')"
				@input="clearSubValues"
				id="selectHierarchy"
				deselectLabel=""
				selectedLabel=""
				selectLabel=""
				class="form-control multi-dropdown"
				:placeholder="filter.placeholder"
				label="name"
				:options="filter.values"
				track-by="name"
				:multiple="false"
				:taggable="false"
			></multiselect>
		</div>
		<div v-else-if="filter.type == 'multiselect'">
			<multiselect
				v-model="filter.value"
				class="form-control multi-dropdown"
				:disabled="filter.disabled"
				:placeholder="filter.placeholder"
				label="name"
				deselectLabel=""
				selectedLabel=""
				selectLabel=""
				:options="filter.values"
				track-by="name"
				:multiple="true"
				:taggable="false"
			></multiselect>
		</div>

		<div v-else-if="filter.type == 'select_value'" class="row">
			<multiselect
				v-model="filter.value"
				class="form-control col-md-7 multi-dropdown"
				:placeholder="filter.placeholder"
				label="name"
				deselectLabel=""
				selectedLabel=""
				selectLabel=""
				:options="filter.values"
				:taggable="false"
				track-by="name"
				:multiple="false"
			></multiselect>
			<!-- <input type="nymber" v-if="filter.value.name" class="form-control col-md-3" v-model="filter.value.code"/> -->
			<input
				type="number"
				v-if="filter.value && filter.value.name == '(Range)'"
				v-model="filter.value.code1"
				class="form-control col-md-2"
				style="margin-left:10px;margin-top:4px !important"
			>
			<input
				type="number"
				v-if="filter.value && filter.value.name == '(Range)'"
				v-model="filter.value.code2"
				class="form-control col-md-2"
				style="margin-left:7px;margin-top:4px !important"
			>
			<input
				type="number"
				v-else-if="filter.value && filter.value.name != '(Range)'"
				v-model="filter.value.code"
				class="form-control col-md-3"
				style="margin-left:13px;margin-top:4px !important"
			>
		</div>
	</div>
</template>

<script>
	import Multiselect from "vue-multiselect";
	import moment from "moment";
	export default {
		components: { Multiselect },
		props: { filter: { type: Object, required: true } },

		watch: {},
		computed: {},
		data() {
			return {};
		},
		methods: {
			clearSubValues() {
				this.filter.subHierarchy.value = null;
				this.filter.subHierarchy.values = [];
			},
			fetchDynamicList(type) {
				if (type == "selectHierarchy" && this.filter.label == "Vendor") {
					var x = document.getElementById("selectHierarchy").value;
					this.$emit("fetchDynamicHierarchyList", x);
				}
				 else if (type == "selectsubHierarchy") {
					var x = document.getElementById("selectsubHierarchy").value;
					this.$emit("fetchDynamicSubHierarchyList", x, this.filter.placeholder);
				}
				 else if (
					this.filter.label == "Vendor" &&
					this.filter.type == "select"
				) {
					var x = document.getElementById("select").value;
					this.$emit("fetchDynamicList", x);
				}
			}
		}
	};
</script>

<style scoped>
.number input[type="number"] {
	-moz-appearance: textfield;
}
.number input::-webkit-outer-spin-button,
.number input::-webkit-inner-spin-button {
	-webkit-appearance: none;
}
/* >>>.v-list__tile{
  height: 36px !important;
} */
</style>

<style lang="scss">
.multiselect__tags {
	border: none !important;
}
.multiselect__tag {
	background: teal !important;
}

.filter {
	.multiselect__tag{
		text-transform:none !important
	}
}
.filter {
	.multiselect__single{
		text-transform: none !important;
		overflow: hidden;
	}
}
.filter {
	.multiselect__option span{
		text-transform: none !important;
	}
}
</style>
